import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";
import Chartcontext from "../../Context/Chartcontext";
import CommentContext from "../../Context/CommentContext/CommentContext";
import {
  getChartAuditInfo,
  saveChartAuditInfo,
  saveChartInfo,
  updateNewAuditInfo,
} from "../../services/chartService";
import {
  qcStatusConstants,
  userRole,
  milestoneConstants,
} from "../../utils/constants";
import role from "../../utils/role";
import AuthContext from "../Auth/Middleware/AuthContext";
import validate from "../ChartDetails/AuditInformationFormValidation";
import validation from "./ChartFormValidationRules";
import NewAuditAreaInformation from "./NewAuditAreaInformation";
import configurationAPI from "../../apis/configuration/configurationAPI";

function AuditInformation({
  configureField,
  data,
  masterData,
  enabled,
  clientData,
  handleManagerSubmit,
  isMangerSubmit,
  setIsTouched,
  setBtnDisable,
}) {
  const { defaultQC, setDefaultQC, setIsQc } = useContext(Chartcontext);
  const [auditDetail, setAuditDetail] = useState([]);
  const [defaultEM, setDefaultEM] = useState();
  const [defaultProcedures, setProcedures] = useState([]);
  const [defaultPrimaryDiagnosis, setPrimaryDiagnosis] = useState([]);
  const [defaultSecondaryDiagnosis, setSecondaryDiagnosis] = useState([]);
  const [defaultModifier, setDefaultModifier] = useState([]);
  const [defaultPOA, setDefaultPOA] = useState([]);
  const [defaultDRG, setDefaultDRG] = useState([]);
  const [auditInfo, setAuditInfo] = useState({});
  const [defaultFeed, setDefaultField] = useState({});
  const [selectedEdTotal, setSelectedEdTotal] = useState();
  const [selectedEdCorrect, setSelectedEdCorrect] = useState();
  const [defaultAllocateToCoder, setDefaultAllocateToCoder] = useState({});
  const [flag, setFlag] = useState(false);
  const [defaultAllocateToAuditor, setDefaultAllocateToAuditor] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [newAuditAreas, setNewAuditAreas] = useState([]);
  const [newAuditInfo, setNewAuditInfo] = useState({});
  const [newAuditInfoUpdatedData, setNewAuditInfoUpdatedData] = useState({});
  const [newAuditAreasError, setNewAuditAreasError] = useState(false);
  const [newAuditAreaTotal, setNewAuditAreaTotal] = useState({});
  const chartId = useParams();

  let [, setFeedbackError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sumOfCodes, setSumofCodes] = useState({
    prim_diag_total: 0,
    proc_total: 0,
    sec_diag_total: 0,
    ed_em_total: 0,
    modifier_total: 0,
  });
  const [sumOfCorrectCodes, setSumOfCorrectCodes] = useState({
    prim_diag_correct: 0,
    proc_correct: 0,
    sec_diag_correct: 0,
    ed_em_correct: 0,
    modifier_correct: 0,
  });
  const [total, setTotal] = useState(0);
  const [correctSum, setCorrectSum] = useState(0);
  const options = [
    { value: "0", label: "0" },
    { value: "1", label: "1" },
  ];
  const auth = useContext(AuthContext);
  const {
    inpval,
    defaultFacility,
    defaultAudit,
    defaultHold,
    defaultPrimaryHealth,
    defaultSubSpecialty,
    defaultResponsible,
    defaultChartStatus,
    defaultDisposition,
    allocateAuditor,
    priority,
  } = useContext(Chartcontext);
  const {
    commentInpval,
    errors,
    setErrors,
    commentedInCommentLog,
    setErrorsFromAuditorToChart,
  } = useContext(CommentContext);
  const { id } = useParams();

  const fetchRecords = (id) => {
    getChartAuditInfo(id)
      .then((data) => {
        setIsQc(data?.data?.QCStatusId ?? null);
        setDefaultQC(data?.data?.QCStatus ?? null);
        setAuditDetail(data?.data);
        setDefaultEM(data?.data?.EdEmFeedbacks);
        setProcedures(data?.data?.ProceduresFeedbacks);
        setPrimaryDiagnosis(data?.data?.PrimDiagFeedbacks);
        setSecondaryDiagnosis(data?.data?.SecDiagFeedbacks);
        setDefaultModifier(data?.data?.ModifierFeedbacks);
        setDefaultPOA(data?.data?.PoaIndFeedbacks);
        setDefaultDRG(data?.data?.DrgValFeedbacks);
        setSelectedEdTotal({
          value: data?.data?.ed_em_total,
          label: data?.data?.ed_em_total,
        });
        setSelectedEdCorrect({
          value: data?.data?.ed_em_correct,
          label: data?.data?.ed_em_correct,
        });
        setDefaultField({
          value: data?.data?.FeedbackType?.value ?? null,
          label: data?.data?.FeedbackType?.label ?? null,
        });
        setAuditInfo({
          ed_em_correct: parseFloat(data?.data?.ed_em_correct ?? ""),
          ed_em_total: parseFloat(data?.data?.ed_em_total ?? ""),
          QCStatusId: parseFloat(data?.data?.QCStatus?.value ?? ""),
          FeedbackTypeId: parseFloat(data?.data?.FeedbackType?.value ?? ""),
          modifier_correct: parseFloat(data?.data?.modifier_correct ?? ""),
          modifier_total: parseFloat(data?.data?.modifier_total ?? ""),
          prim_diag_correct: parseFloat(data?.data?.prim_diag_correct ?? ""),
          prim_diag_total:
            Object.keys(data?.data).length === 1
              ? 1
              : parseFloat(data?.data?.prim_diag_total ?? ""),
          proc_correct: parseFloat(data?.data?.proc_correct ?? ""),
          proc_total: parseFloat(data?.data?.proc_total ?? ""),
          sec_diag_correct: parseFloat(data?.data?.sec_diag_correct ?? ""),
          sec_diag_total: parseFloat(data?.data?.sec_diag_total ?? ""),
          poa_correct: parseFloat(data?.data?.poa_correct ?? ""),
          poa_total: parseFloat(data?.data?.poa_total ?? ""),
          drg_total: parseFloat(data?.data?.drg_total ?? ""),
          drg_correct: parseFloat(data?.data?.drg_correct ?? ""),
        });
        setTotal(data?.data?.total_total);
        setCorrectSum(data?.data?.total_correct);
        setSumofCodes({
          prim_diag_total:
            Object.keys(data?.data).length === 1
              ? 1
              : parseFloat(data?.data?.prim_diag_total ?? ""),
          proc_total: data?.data?.proc_total,
          sec_diag_total: data?.data?.sec_diag_total,
          ed_em_total: data?.data?.ed_em_total,
          modifier_total: data?.data?.modifier_total,
          poa_total: data?.data?.poa_total,
          drg_total: data?.data?.drg_total,
        });
        setSumOfCorrectCodes({
          prim_diag_correct: data?.data?.prim_diag_correct,
          proc_correct: data?.data?.proc_correct,
          sec_diag_correct: data?.data?.sec_diag_correct,
          ed_em_correct: data?.data?.ed_em_correct,
          modifier_correct: data?.data?.modifier_correct,
          poa_correct: data?.data?.poa_correct,
          drg_correct: data?.data?.drg_correct,
        });
        setDefaultAllocateToAuditor(
          Object.keys(data?.data).length === 1
            ? { label: clientData?.Coder?.name, value: clientData?.Coder?.id }
            : {
                label: data?.data?.next_user?.name,
                value: data?.data?.next_user?.id,
              },
        );
        setDefaultAllocateToCoder(
          Object.keys(data?.data).length === 1
            ? { label: clientData?.Coder?.name, value: clientData?.Coder?.id }
            : {
                label: data?.data?.next_user?.name,
                value: data?.data?.next_user?.id,
              },
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const renderEDEM = () => {
    return masterData?.ed_em_feed?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderProcedures = () => {
    return masterData?.procedure_feed?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderPrimaryDiagnosis = () => {
    return masterData?.prim_diag_feed?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderSecondaryDiagnosis = () => {
    return masterData?.sec_diag_feed?.map((data) => ({
      label: data?.name,
      value: data?.id,
    }));
  };

  const renderModifier = () => {
    return masterData?.modifier_feed?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderPOA = () => {
    return masterData?.poa_indicator_feed?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderDrugValue = () => {
    return masterData?.drug_value_feed?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const renderQC = () => {
    if (
      (auth.role === userRole.Auditor ||
        auth.role === userRole.TL ||
        auth.role === userRole.Manager) &&
      (clientData?.MilestoneId ===
        milestoneConstants.READY_TO_AUDIT_MILESTONE_ID ||
        clientData?.MilestoneId ===
          milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID)
    ) {
      return masterData?.qc_status
        ?.filter(
          (data) =>
            data.id === qcStatusConstants.QC_FAIL_ID ||
            data.id === qcStatusConstants.QC_PASS_ID,
        )
        .map((data) => ({
          label: data.name,
          value: data.id,
        }));
    }
  };

  const renderAllocateToCoder = () => {
    let coderAuditor = [];

    // Add Active Coders
    coderAuditor = coderAuditor.concat(
      masterData?.coders_active?.map((data) => ({
        label: `${data.name} (Coder)`,
        value: data.id,
      })),
    );

    coderAuditor.sort((a, b) => a.label.localeCompare(b.label));

    return coderAuditor;
  };

  const renderFeed = () => {
    return masterData?.feedback_types?.map((data) => ({
      label: data.name,
      value: data.id,
    }));
  };

  const handleEMED = (event) => {
    if (
      selectedEdTotal?.value !== selectedEdCorrect?.value &&
      selectedEdTotal?.value > selectedEdCorrect?.value
    ) {
      setDefaultEM(event);
      setFlag(true);
    }
  };

  const handleProcedures = (event) => {
    if (
      auditInfo?.proc_total !== auditInfo?.proc_correct &&
      auditInfo?.proc_total > auditInfo?.proc_correct
    ) {
      setProcedures(event);
      setFlag(true);
    }
  };

  const handlePrimaryDiagnosis = (event) => {
    if (
      auditInfo?.prim_diag_total !== auditInfo?.prim_diag_correct &&
      auditInfo?.prim_diag_total > auditInfo?.prim_diag_correct
    ) {
      setPrimaryDiagnosis(event);
      setFlag(true);
    }
  };

  const handleSecondaryDiagnosis = (event) => {
    if (
      auditInfo?.sec_diag_total !== auditInfo?.sec_diag_correct &&
      auditInfo?.sec_diag_total > auditInfo?.sec_diag_correct
    ) {
      setSecondaryDiagnosis(event);
      setFlag(true);
    }
  };

  const handleModifier = (event) => {
    if (
      auditInfo?.modifier_total !== auditInfo?.modifier_correct &&
      auditInfo?.modifier_total > auditInfo?.modifier_correct
    ) {
      setDefaultModifier(event);
      setFlag(true);
    }
  };

  const handlePOA = (event) => {
    if (
      auditInfo?.poa_total !== auditInfo?.poa_correct &&
      auditInfo?.poa_total > auditInfo?.poa_correct
    ) {
      setDefaultPOA(event);
      setFlag(true);
    }
  };

  const handleDRG = (event) => {
    if (
      auditInfo?.drg_total !== auditInfo?.drg_correct &&
      auditInfo?.drg_total > auditInfo?.drg_correct
    ) {
      setDefaultDRG(event);
      setFlag(true);
    }
  };

  const handledefaultQC = (event) => {
    if (auth.role === role.Auditor) {
      if (event.value !== 2) {
        setDefaultAllocateToAuditor("");
        setFeedbackError(false);
        setFlag(true);
      }
      if (event.value === 2) {
        setFeedbackError(true);
        setDefaultAllocateToAuditor(
          Object.keys(auditDetail).length === 1
            ? { label: clientData?.Coder?.name, value: clientData?.Coder?.id }
            : {
                label: auditDetail?.next_user?.name,
                value: auditDetail?.next_user?.id,
              },
        );
        setFlag(true);
      }
    }
    setDefaultQC(event);
  };

  const handledefaultFeed = (event) => {
    if (
      (auditInfo?.prim_diag_total !== auditInfo?.prim_diag_correct &&
        auditInfo?.prim_diag_total > auditInfo?.prim_diag_correct) ||
      (auditInfo?.sec_diag_total !== auditInfo?.sec_diag_correct &&
        auditInfo?.sec_diag_total > auditInfo?.sec_diag_correct) ||
      (auditInfo?.proc_total !== auditInfo?.proc_correct &&
        auditInfo?.proc_total > auditInfo?.proc_correct) ||
      (selectedEdTotal?.value !== selectedEdCorrect?.value &&
        selectedEdTotal?.value > selectedEdCorrect?.value) ||
      (auditInfo?.modifier_total !== auditInfo?.modifier_correct &&
        auditInfo?.modifier_total > auditInfo?.modifier_correct) ||
      (auditInfo?.poa_total !== auditInfo?.poa_correct &&
        auditInfo?.poa_total > auditInfo?.poa_correct) ||
      (auditInfo?.drg_total !== auditInfo?.drg_correct &&
        auditInfo?.drg_total > auditInfo?.drg_correct)
    ) {
      setDefaultField(event);
      setFlag(true);
    }
  };

  const handleDefaultAllocateToCoder = (event) => {
    setDefaultAllocateToAuditor(event);
    setDefaultAllocateToCoder(event);
    setFlag(true);
  };

  const handleInputChange = async (e) => {
    if (
      e.target.name === "prim_diag_correct" ||
      e.target.name === "prim_diag_total"
    ) {
      if (auditInfo?.prim_diag_total <= auditInfo?.prim_diag_correct) {
        setPrimaryDiagnosis(null);
      }
    }
    if (
      e.target.name === "sec_diag_correct" ||
      e.target.name === "sec_diag_total"
    ) {
      if (auditInfo?.sec_diag_total <= auditInfo?.sec_diag_correct) {
        setSecondaryDiagnosis([]);
      }
    }
    if (e.target.name === "proc_correct" || e.target.name === "proc_total") {
      if (auditInfo?.proc_total <= auditInfo?.proc_correct) {
        setProcedures([]);
      }
    }
    if (
      e.target.name === "modifier_correct" ||
      e.target.name === "modifier_total"
    ) {
      if (auditInfo?.modifier_total <= auditInfo?.modifier_correct) {
        setDefaultModifier([]);
      }
    }
    if (e.target.name === "poa_correct" || e.target.name === "poa_total") {
      if (auditInfo?.poa_total <= auditInfo?.poa_correct) {
        setDefaultPOA([]);
      }
    }
    if (e.target.name === "drg_correct" || e.target.name === "drg_total") {
      if (auditInfo?.drg_total <= auditInfo?.drg_correct) {
        setDefaultDRG([]);
      }
    }

    setAuditInfo((auditInfo) => ({
      ...auditInfo,
      [e.target.name]: parseFloat(e.target.value),
    }));
    if (e.target.name.includes("total")) {
      await setSumofCodes((sumOfCodes) => {
        return { ...sumOfCodes, [e.target.name]: parseFloat(e.target.value) };
      });
    }
    if (e.target.name.includes("correct")) {
      await setSumOfCorrectCodes((sumOfCorrectCodes) => {
        return {
          ...sumOfCorrectCodes,
          [e.target.name]: parseFloat(e.target.value),
        };
      });
    }
    setFlag(true);
  };

  const reduceTotalValue = (x) => {
    const values = Object.values(x);
    const sum = values.reduce((accumulator, value) => {
      return accumulator + value;
    }, 0);
    setTotal(sum);
  };

  const reduceCorrectValue = (x) => {
    const values = Object.values(x);
    const sum = values.reduce((accumulator, value) => {
      return accumulator + value;
    }, 0);
    setCorrectSum(sum);
  };

    const correctSumReducer = () => {
      const sum = Object.values(newAuditInfoUpdatedData).reduce((acc, value) => acc + (value?.correct || 0), 0);
    setNewAuditAreaTotal((prev) => ({
      ...prev,
      correct: sum
    }));
  };
  const totalSumReducer = () => {
    const sum = Object.values(newAuditInfoUpdatedData).reduce((acc, value) => acc + (value?.total || 0), 0);
    setNewAuditAreaTotal((prev) => ({
      ...prev,
      total: sum
    }));
  };


  const handleSelectedEdTotal = (event) => {
    setSelectedEdTotal(event);
    setSumofCodes((sumOfCodes) => ({
      ...sumOfCodes,
      ed_em_total: parseFloat(event.value),
    }));
    if (
      auditInfo?.ed_em_total <= auditInfo?.ed_em_correct ||
      event?.value <= selectedEdCorrect?.value
    ) {
      setDefaultEM(null);
      setFlag(true);
    }
  };

  const handleSelectedEdCorrect = (event) => {
    setSelectedEdCorrect(event);
    setSumOfCorrectCodes((sumOfCorrectCodes) => ({
      ...sumOfCorrectCodes,
      ed_em_correct: parseFloat(event.value),
    }));
    if (
      auditInfo?.ed_em_total <= auditInfo?.ed_em_correct ||
      selectedEdTotal?.value <= event.value
    ) {
      setDefaultEM(null);
      setFlag(true);
    }
  };
  
  const validateAuditInfoForNewAuditAreas = (data) => {
    let error = false;
    const dataForValidation = data || newAuditInfoUpdatedData;
    const newAuditAreasErrorCopy = { ...newAuditAreasError };
    Object.keys(dataForValidation).forEach((key) => {
      if ((!dataForValidation[key].total && dataForValidation[key].total !== 0)) {
        newAuditAreasErrorCopy[key] = {
          totalCodes: !parseInt(dataForValidation[key].total) ? 'Required' : false,
          correctCodes: false,
          feedbackCategory: false,
        };
        error = true;
      }
      else if (!dataForValidation[key].correct && dataForValidation[key].correct !== 0) {
        newAuditAreasErrorCopy[key] = {
          totalCodes: false,
          correctCodes: !parseInt(dataForValidation[key].correct) ? 'Required' : false,
          feedbackCategory: false,
        };
        error = true;
      }
      else if (parseInt(dataForValidation[key].total) < parseInt(dataForValidation[key].correct)) {
          newAuditAreasErrorCopy[key] = {
            totalCodes: 'Total should be greater than or equal to correct',
            correctCodes: false,
            feedbackCategory: false,
          };
        error = true;
      } else if ((parseInt(dataForValidation[key].total) > parseInt(dataForValidation[key].correct) && (!dataForValidation[key].feedbackCategoryDropdown || !dataForValidation[key].feedbackCategoryDropdown?.value))) {
        newAuditAreasErrorCopy[key] = {
          totalCodes: false,
          correctCodes: false,
          feedbackCategory: 'Required',
        };
        error = true;
      } else {
        newAuditAreasErrorCopy[key] = {
          totalCodes: false,
          correctCodes: false,
          feedbackCategory: false,
        };
      }
    });

    setNewAuditAreasError(newAuditAreasErrorCopy);
    return error;
  }
  const decimalRegex = /^\d+\.\d+$/;

  const updateAuditInfoForNewAuditAreas = async () => {
    try {
      const reqBody = {};
      Object.keys(newAuditInfoUpdatedData).forEach((key) => {
        reqBody[key] = {
          totalCodes: newAuditInfoUpdatedData[key].total,
          correctCodes: newAuditInfoUpdatedData[key].correct,
          FeedbackCategoryDropdownId: newAuditInfoUpdatedData[key].feedbackCategoryDropdown?.value,
          FeedbackCategoryId: newAuditInfoUpdatedData[key].feedbackCategoryId
        };
      });
      const res = await updateNewAuditInfo(reqBody, id);
      if (res.success) {
        fetchNewAuditInfo();
      }
      
    }catch (error) {
      console.log(error);
    }
  };

  const submitChartForm = async () => {
    // Removed as the condition is of no use
    // if (
    //   auth.role === role?.Auditor ||
    //   auth.role === role?.Manager ||
    //   auth.role === role?.TeamLead
    // ) {
    //   await getChartAuditInfo(id);
    // }
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {

      if (clientData?.MilestoneId === milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID) {
        const isError = validateAuditInfoForNewAuditAreas();
        if (isError) {
          return;
        }
      }

      let object = inpval;
      const currentRole = localStorage.getItem("Role");
      object = {
        ...object,
        HoldReasons: defaultHold?.map((item) => item.value),
        DispositionId: defaultDisposition?.value ?? clientData?.DispositionId,
        FacilityId: defaultFacility?.value ?? clientData?.FacilityId,
        PrimaryHealthId: defaultPrimaryHealth?.value ?? clientData?.PrimaryHealthId,
        SubSpecialtyId: defaultSubSpecialty?.value,
        ResponsibleParties: defaultResponsible ? defaultResponsible.map((item) => item.value) : clientData?.ResponsibleParties?.map((item) => item.value),
        StatusId: defaultChartStatus?.value,
        QCStatusId: defaultQC?.value,
        AuditOptions: defaultAudit?.map((item) => item.value),
        next_user_id:
          clientData?.MilestoneId === 3 ? allocateAuditor?.value : null,
        comment_msg:
          commentedInCommentLog === true ? commentInpval?.comment_msg : null,
        priority: priority ? priority.value : null,
      };
      let isValid =
        clientData?.MilestoneId === 3 || clientData?.MilestoneId === 6
          ? await validationSchema(object, clientData)
          : false;
      if (
        currentRole === userRole.Manager ||
        currentRole === userRole.Auditor ||
        currentRole === userRole.TL ||
        auth.role === role?.TeamLead
      ) {
        if (isValid) {
          setErrorsFromAuditorToChart({});
          const res = await saveChartInfo(id, object, errors, clientData);
          if (res === true) {
            setIsSubmitted(true);
            setBtnDisable(true);
            setIsTouched(false);
          }
        }
      }

      let obj = auditInfo;
      obj = {
        ...obj,
        PrimDiagFeedbacks: defaultPrimaryDiagnosis?.value ?? null,
        SecDiagFeedbacks:
          defaultSecondaryDiagnosis?.map((item) => item.value) ?? null,
        ProceduresFeedbacks: defaultProcedures?.map((item) => item.value) ?? null,
        EdEmFeedbacks: defaultEM?.value ?? null,
        ModifierFeedbacks: defaultModifier?.map((item) => item.value) ?? null,
        POAFeedbacks: defaultPOA?.map((item) => item.value) ?? null,
        DrugFeedbacks: defaultDRG?.map((item) => item.value) ?? null,
        QCStatusId: defaultQC?.value,
        FeedbackTypeId: defaultFeed?.value,
        ed_em_total: selectedEdTotal?.value,
        ed_em_correct: selectedEdCorrect?.value,
        next_user_id:
          defaultQC?.value === 2 ? defaultAllocateToAuditor?.value : null,
        total_total: total + newAuditAreaTotal?.total,
        total_correct: correctSum + newAuditAreaTotal?.correct,
        comment_msg:
          commentedInCommentLog === true ? commentInpval?.comment_msg : null,
      };
      if (
        obj?.prim_diag_total === obj?.prim_diag_correct &&
        obj?.sec_diag_total === obj?.sec_diag_correct &&
        obj?.proc_total === obj?.proc_correct &&
        obj?.ed_em_total === obj?.ed_em_correct &&
        obj?.modifier_total === obj?.modifier_correct &&
        obj?.poa_total === obj?.poa_correct &&
        obj?.drg_total === obj?.drg_correct
      ) {
        obj.FeedbackTypeId = null;
      }
      if (obj.QCStatusId === 2) {
        setFeedbackError(true);
      }
      let boolValid = false;
      if (
        auth.role === role?.Auditor ||
        auth.role === role?.Manager ||
        auth.role === role?.TeamLead
      ) {
        boolValid =
          clientData?.MilestoneId === 6
            ? await validateSchema(obj, auditDetail, clientData)
            : false;
      }
      if (boolValid && isValid) {
        setErrors({});
        updateAuditInfoForNewAuditAreas();
        const data = await saveChartAuditInfo(id, obj, clientData);
        if (data) {
          setIsSubmitted(true);
          setFeedbackError(false);
          setBtnDisable(true);
          setIsTouched(false);
          localStorage.setItem("isFormDirty", false);
        }
      }

    } catch (error) {
      console.log(error);
    } finally{
      if (isMangerSubmit === true) {
        handleManagerSubmit(false);
      }
      setIsSubmitting(false);
    }
  };

  const validateSchema = async (obj, auditDetail, clientData) => {
    const response = await validate(obj, auditDetail, clientData);
    if (Object.keys(response).length === 0) {
      return true;
    } else {
      setErrors(response);
      return false;
    }
  };

  const validationSchema = async (object, clientData) => {
    const response = await validation(object, clientData, masterData, configureField);
    if (Object.keys(response).length === 0) {
      return true;
    } else {
      setErrorsFromAuditorToChart(response);
      return false;
    }
  };

  const handleKeypress = (e) => {
    if (
      e.target.name === "prim_diag_correct" ||
      e.target.name === "prim_diag_total"
    ) {
      if (auditInfo?.prim_diag_total <= auditInfo?.prim_diag_correct) {
        setPrimaryDiagnosis(null);
      }
    }
    if (
      e.target.name === "sec_diag_correct" ||
      e.target.name === "sec_diag_total"
    ) {
      if (auditInfo?.sec_diag_total <= auditInfo?.sec_diag_correct) {
        setSecondaryDiagnosis([]);
      }
    }
    if (e.target.name === "proc_correct" || e.target.name === "proc_total") {
      if (auditInfo?.proc_total <= auditInfo?.proc_correct) {
        setProcedures([]);
      }
    }
    if (e.target.name === "ed_em_correct" || e.target.name === "ed_em_total") {
      if (auditInfo?.ed_em_total <= auditInfo?.ed_em_correct) {
        setDefaultEM(null);
      }
    }
    if (
      e.target.name === "modifier_correct" ||
      e.target.name === "modifier_total"
    ) {
      if (auditInfo?.modifier_total <= auditInfo?.modifier_correct) {
        setDefaultModifier([]);
      }
    }

    if (e.target.name === "poa_correct" || e.target.name === "poa_total") {
      if (auditInfo?.poa_total <= auditInfo?.poa_correct) {
        setDefaultPOA([]);
      }
    }
    if (e.target.name === "drg_correct" || e.target.name === "drg_total") {
      if (auditInfo?.drg_total <= auditInfo?.drg_correct) {
        setDefaultDRG([]);
      }
    }
    if (e.keyCode === 8) {
      setAuditInfo((auditInfo) => ({
        ...auditInfo,
        [e.target.name]: parseFloat(e.target.value),
      }));
    }
    setFlag(true);
  };

  useEffect(() => {
    if (
      auditInfo?.prim_diag_total === auditInfo?.prim_diag_correct &&
      auditInfo?.sec_diag_total === auditInfo?.sec_diag_correct &&
      auditInfo?.proc_total === auditInfo?.proc_correct &&
      selectedEdTotal?.value === selectedEdCorrect?.value &&
      auditInfo?.modifier_total === auditInfo?.modifier_correct &&
      auditInfo.poa_total === auditInfo.poa_correct &&
      auditInfo.drg_total === auditInfo.drg_correct
    ) {
    }
    if (defaultQC?.value !== 2) {
      setDefaultAllocateToAuditor("");
      setDefaultAllocateToCoder("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {}, [commentInpval, defaultAllocateToAuditor, auditDetail]);

  useEffect(() => {
    reduceTotalValue(sumOfCodes);
    reduceCorrectValue(sumOfCorrectCodes);
  }, [
    auditInfo,
    auditDetail,
    defaultEM,
    defaultModifier,
    defaultPrimaryDiagnosis,
    defaultProcedures,
    defaultSecondaryDiagnosis,
    defaultFeed,
    defaultQC,
    selectedEdTotal,
    errors,
    sumOfCodes,
    sumOfCorrectCodes,
  ]);

  useEffect(() => {
    correctSumReducer();
    totalSumReducer();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newAuditInfoUpdatedData]);


  useEffect(() => {
    fetchRecords(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

  useEffect(() => {
    if (commentInpval) {
      commentInpval.comment_msg = null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
  useEffect(() => {
    if (isMangerSubmit === true) {
      submitChartForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMangerSubmit]);

  useEffect(() => {
    localStorage.setItem("isFormDirty", true);
    if(flag) setIsTouched(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flag]);


  const fetchNewAuditAreas = async () => {
    try {
      const response = await configurationAPI.getAuditAreas({
        clientId: clientData?.ClientId,
        locationId: clientData?.LocationId,
      });
      if (response.success) {
        setNewAuditAreas(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchNewAuditInfo = async () => {
    try {
      const response = await configurationAPI.getNewAuditInfo(chartId?.id);
      if (response.success) {
        setNewAuditInfo(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNewAuditAreas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchNewAuditInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled])

  return (
    <>
      <div className="card pt-4 mb-6 mb-xl-9">
        <div className="card-header border-0 minimize">
          <div className="card-title">
            <h2>Audit Information</h2>
          </div>
          <div className="card-toolbar mt-0">
            <button className="btn btn-icon btn-sm btn-light-primary justify-content-center">
              <i
                className={
                  clientData?.MilestoneId ===
                    milestoneConstants.READY_TO_CODE_MILESTONE_ID ||
                  clientData?.MilestoneId ===
                    milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
                  clientData?.MilestoneId ===
                    milestoneConstants.CODING_DONE_MILESTONE_ID
                    ? "fas fa-plus"
                    : "fas fa-minus"
                }
              />
            </button>
          </div>
        </div>
        <div
          className="card-body p-0 collapse"
          style={{
            display:
              clientData?.MilestoneId ===
                milestoneConstants.READY_TO_CODE_MILESTONE_ID ||
              clientData?.MilestoneId ===
                milestoneConstants.CODING_IN_PROGRESS_MILESTONE_ID ||
              clientData?.MilestoneId ===
                milestoneConstants.CODING_DONE_MILESTONE_ID
                ? "none"
                : "block",
          }}
        >
          <div className="table-responsive audit-information-table mb-6 mt-0 m-8">
            <table className="table table-rounded mb-5 gs-10 gy-5">
              <thead>
                <tr className="border-bottom text-muted fw-bold fs-7 text-uppercase gs-0">
                  <th className="min-w-175px pb-2">Area</th>
                  <th width="25%" className="pb-2">
                    TOTAL CODES
                  </th>
                  <th width="25%" className="pb-2">
                    CORRECT CODES
                  </th>
                  <th width="25%" className="pb-2">
                    FEEDBACK CATEGORY
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-left pt-5">Primary Diagnosis</td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      className="form-control"
                      name="prim_diag_total"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId === 6 ? !enabled : true)
                      }
                      defaultValue={
                        auditDetail !== undefined && auditDetail != null
                          ? Object.keys(auditDetail)?.length === 1 &&
                            (inpval?.primary_diagnosis === null ||
                              inpval?.primary_diagnosis?.trim() === "")
                            ? null
                            : auditInfo?.prim_diag_total
                          : ""
                      }
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.prim_diag_total &&
                      isNaN(auditInfo?.prim_diag_total) && (
                        <p className="help is-danger errorDanger">Required</p>
                      )}
                    {errors.prim_diag_total &&
                      auditInfo?.prim_diag_total <
                        auditInfo?.prim_diag_correct &&
                      !decimalRegex.test(auditInfo?.prim_diag_total) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.prim_diag_total &&
                      decimalRegex.test(auditInfo?.prim_diag_total) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="prim_diag_correct"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      defaultValue={auditDetail?.prim_diag_correct}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.prim_diag_correct &&
                      isNaN(auditInfo?.prim_diag_correct) && (
                        <p className="help is-danger errorDanger">Required</p>
                      )}
                    {errors.prim_diag_correct &&
                      auditInfo?.prim_diag_total <
                        auditInfo?.prim_diag_correct &&
                      !decimalRegex.test(auditInfo?.prim_diag_correct) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.prim_diag_correct &&
                      decimalRegex.test(auditInfo?.prim_diag_correct) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    {auditInfo?.prim_diag_total !==
                      auditInfo?.prim_diag_correct &&
                    auditInfo?.prim_diag_total >
                      auditInfo?.prim_diag_correct ? (
                      <Select
                        name="PrimDiagFeedbacks"
                        options={renderPrimaryDiagnosis()}
                        isMulti={false}
                        value={defaultPrimaryDiagnosis}
                        isDisabled={
                          !enabled ||
                          isSubmitting ||
                          isSubmitted ||
                          (clientData?.MilestoneId ===
                          milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                            ? !enabled
                            : true)
                        }
                        onChange={handlePrimaryDiagnosis}
                      />
                    ) : (
                      <Select
                        name="PrimDiagFeedbacks"
                        options={[]}
                        isMulti={false}
                        value={null}
                        isDisabled={true}
                        onChange={handlePrimaryDiagnosis}
                      />
                    )}
                    {errors.PrimDiagFeedbacks &&
                      (defaultPrimaryDiagnosis?.value === undefined ||
                        defaultPrimaryDiagnosis?.value === null) &&
                      auditInfo?.prim_diag_total !==
                        auditInfo?.prim_diag_correct && (
                        <p className="help is-danger errorDanger">
                          {errors.PrimDiagFeedbacks}
                        </p>
                      )}
                  </td>
                </tr>
                <tr>
                  <td className="text-left pt-5">Secondary Diagnosis</td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="sec_diag_total"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      defaultValue={auditDetail?.sec_diag_total}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.sec_diag_total &&
                      isNaN(auditInfo?.sec_diag_total) && (
                        <p className="help is-danger errorDanger">Required</p>
                      )}
                    {errors.sec_diag_total &&
                      auditInfo?.sec_diag_total < auditInfo?.sec_diag_correct &&
                      !decimalRegex.test(auditInfo?.sec_diag_total) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.sec_diag_total &&
                      decimalRegex.test(auditInfo?.sec_diag_total) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="sec_diag_correct"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      defaultValue={auditDetail?.sec_diag_correct}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.sec_diag_correct &&
                      isNaN(auditInfo?.sec_diag_correct) && (
                        <p className="help is-danger errorDanger">Required</p>
                      )}
                    {errors.sec_diag_correct &&
                      auditInfo?.sec_diag_total < auditInfo?.sec_diag_correct &&
                      !decimalRegex.test(auditInfo?.sec_diag_correct) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.sec_diag_correct &&
                      decimalRegex.test(auditInfo?.sec_diag_correct) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    {auditInfo?.sec_diag_total !==
                      auditInfo?.sec_diag_correct &&
                    auditInfo?.sec_diag_total > auditInfo?.sec_diag_correct ? (
                      <Select
                        options={renderSecondaryDiagnosis()}
                        isMulti={true}
                        value={defaultSecondaryDiagnosis}
                        isDisabled={
                          !enabled ||
                          isSubmitting ||
                          isSubmitted ||
                          (clientData?.MilestoneId ===
                          milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                            ? !enabled
                            : true)
                        }
                        onChange={handleSecondaryDiagnosis}
                      />
                    ) : (
                      <Select
                        options={[]}
                        isMulti={true}
                        value={null}
                        isDisabled={true}
                        onChange={handleSecondaryDiagnosis}
                      />
                    )}
                    {errors.SecDiagFeedbacks &&
                      (defaultSecondaryDiagnosis === undefined ||
                        defaultSecondaryDiagnosis?.length === 0) &&
                      auditInfo?.sec_diag_total !==
                        auditInfo?.sec_diag_correct && (
                        <p className="help is-danger errorDanger">
                          {errors.SecDiagFeedbacks}
                        </p>
                      )}
                  </td>
                </tr>
                <tr>
                  <td className="text-left pt-5">Procedures</td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="proc_total"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      defaultValue={auditDetail?.proc_total}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.proc_total && isNaN(auditInfo?.proc_total) && (
                      <p className="help is-danger errorDanger">Required</p>
                    )}
                    {errors.proc_total &&
                      auditInfo?.proc_total < auditInfo?.proc_correct &&
                      !decimalRegex.test(auditInfo?.proc_total) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.proc_total &&
                      decimalRegex.test(auditInfo?.proc_total) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="proc_correct"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      defaultValue={auditDetail?.proc_correct}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.proc_correct && isNaN(auditInfo?.proc_correct) && (
                      <p className="help is-danger errorDanger">Required</p>
                    )}
                    {errors.proc_correct &&
                      auditInfo?.proc_total < auditInfo?.proc_correct &&
                      !decimalRegex.test(auditInfo?.proc_correct) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.proc_correct &&
                      decimalRegex.test(auditInfo?.proc_correct) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    {auditInfo?.proc_total !== auditInfo?.proc_correct &&
                    auditInfo?.proc_total > auditInfo?.proc_correct ? (
                      <Select
                        options={renderProcedures()}
                        isMulti={true}
                        value={defaultProcedures}
                        onChange={handleProcedures}
                        isDisabled={
                          !enabled ||
                          isSubmitting ||
                          isSubmitted ||
                          (clientData?.MilestoneId ===
                          milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                            ? !enabled
                            : true)
                        }
                      />
                    ) : (
                      <Select
                        options={[]}
                        isMulti={true}
                        value={null}
                        onChange={handleProcedures}
                        isDisabled={true}
                      />
                    )}
                    {errors.ProceduresFeedbacks &&
                      (defaultProcedures === undefined ||
                        defaultProcedures?.length === 0) &&
                      auditInfo?.proc_total !== auditInfo?.proc_correct && (
                        <p className="help is-danger errorDanger">
                          {errors.ProceduresFeedbacks}
                        </p>
                      )}
                  </td>
                </tr>
                <tr>
                  <td className="text-left pt-7" style={{ width: "10%" }}>
                    ED/EM Level
                  </td>
                  <td style={{ width: "5%" }}>
                    <Select
                      name="ed_em_total"
                      isDisabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      options={options}
                      onChange={handleSelectedEdTotal}
                      value={selectedEdTotal}
                    />
                    {errors.ed_em_total &&
                      selectedEdTotal?.value === undefined && (
                        <p className="help is-danger errorDanger">Required</p>
                      )}
                    {errors.ed_em_total &&
                      selectedEdTotal?.value < selectedEdCorrect?.value && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                  </td>
                  <td style={{ width: "5%" }}>
                    <Select
                      name="ed_em_correct"
                      isDisabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      options={options}
                      onChange={handleSelectedEdCorrect}
                      value={selectedEdCorrect}
                    />
                    {errors.ed_em_correct &&
                      selectedEdCorrect?.value === undefined && (
                        <p className="help is-danger errorDanger">Required</p>
                      )}
                    {errors.ed_em_correct &&
                      selectedEdTotal?.value < selectedEdCorrect?.value && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                  </td>
                  <td style={{ width: "80%" }}>
                    {selectedEdTotal?.value !== selectedEdCorrect?.value &&
                    selectedEdTotal?.value > selectedEdCorrect?.value ? (
                      <Select
                        options={renderEDEM()}
                        isMulti={false}
                        value={defaultEM}
                        isDisabled={
                          !enabled ||
                          isSubmitting ||
                          isSubmitted ||
                          (clientData?.MilestoneId ===
                          milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                            ? !enabled
                            : true)
                        }
                        onChange={handleEMED}
                      />
                    ) : (
                      <Select
                        options={[]}
                        isMulti={false}
                        value={null}
                        isDisabled={true}
                        onChange={handleEMED}
                      />
                    )}
                    {errors.EdEmFeedbacks &&
                      (defaultEM === undefined || defaultEM === null) &&
                      selectedEdTotal?.value !== selectedEdCorrect?.value && (
                        <p className="help is-danger errorDanger">
                          {errors.EdEmFeedbacks}
                        </p>
                      )}
                  </td>
                </tr>

                <tr>
                  <td className="text-left pt-5">Modifier</td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="modifier_total"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      defaultValue={auditDetail?.modifier_total}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.modifier_total &&
                      isNaN(auditInfo?.modifier_total) && (
                        <p className="help is-danger errorDanger">Required</p>
                      )}
                    {errors.modifier_total &&
                      auditInfo?.modifier_total < auditInfo?.modifier_correct &&
                      !decimalRegex.test(auditInfo?.modifier_total) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.modifier_total &&
                      decimalRegex.test(auditInfo?.modifier_total) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="modifier_correct"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      defaultValue={auditDetail?.modifier_correct}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.modifier_correct &&
                      isNaN(auditInfo?.modifier_correct) && (
                        <p className="help is-danger errorDanger">Required</p>
                      )}
                    {errors.modifier_correct &&
                      auditInfo?.modifier_total < auditInfo?.modifier_correct &&
                      !decimalRegex.test(auditInfo?.modifier_correct) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.modifier_correct &&
                      decimalRegex.test(auditInfo?.modifier_correct) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    {auditInfo?.modifier_total !==
                      auditInfo?.modifier_correct &&
                    auditInfo?.modifier_total > auditInfo?.modifier_correct ? (
                      <Select
                        options={renderModifier()}
                        isMulti={true}
                        value={defaultModifier}
                        isDisabled={
                          !enabled ||
                          isSubmitting ||
                          isSubmitted ||
                          (clientData?.MilestoneId ===
                          milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                            ? !enabled
                            : true)
                        }
                        onChange={handleModifier}
                      />
                    ) : (
                      <Select
                        options={[]}
                        isMulti={true}
                        value={null}
                        isDisabled={true}
                        onChange={handleModifier}
                      />
                    )}
                    {errors.ModifierFeedbacks &&
                      (defaultModifier === undefined ||
                        defaultModifier?.length === 0) &&
                      auditInfo?.modifier_total !==
                        auditInfo?.modifier_correct && (
                        <p className="help is-danger errorDanger">
                          {errors.ModifierFeedbacks}
                        </p>
                      )}
                  </td>
                </tr>

                <tr>
                  <td className="text-left pt-5">POA Indicator</td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="poa_total"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId === 6 ? !enabled : true)
                      }
                      defaultValue={auditDetail?.poa_total}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.poa_total && isNaN(auditInfo?.poa_total) && (
                      <p className="help is-danger errorDanger">Required</p>
                    )}
                    {errors.poa_total &&
                      auditInfo?.poa_total < auditInfo?.poa_correct &&
                      !decimalRegex.test(auditInfo?.poa_total) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.poa_total &&
                      decimalRegex.test(auditInfo?.poa_total) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="poa_correct"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId === 6 ? !enabled : true)
                      }
                      defaultValue={auditDetail?.poa_correct}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.poa_correct && isNaN(auditInfo?.poa_correct) && (
                      <p className="help is-danger errorDanger">Required</p>
                    )}
                    {errors.poa_correct &&
                      auditInfo?.poa_total < auditInfo?.poa_correct &&
                      !decimalRegex.test(auditInfo?.poa_correct) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.poa_correct &&
                      decimalRegex.test(auditInfo?.poa_correct) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    {auditInfo?.poa_total !== auditInfo?.poa_correct &&
                    auditInfo?.poa_total > auditInfo?.poa_correct ? (
                      <Select
                        options={renderPOA()}
                        isMulti={true}
                        value={defaultPOA}
                        isDisabled={
                          !enabled ||
                          isSubmitting ||
                          isSubmitted ||
                          (clientData?.MilestoneId === 6 ? !enabled : true)
                        }
                        onChange={handlePOA}
                      />
                    ) : (
                      <Select
                        options={[]}
                        isMulti={true}
                        value={null}
                        isDisabled={true}
                        onChange={handlePOA}
                      />
                    )}
                    {errors.ModifierFeedbacks &&
                      (defaultModifier === undefined ||
                        defaultModifier?.length === 0) &&
                      auditInfo?.poa_total !== auditInfo?.poa_correct && (
                        <p className="help is-danger errorDanger">
                          {errors.ModifierFeedbacks}
                        </p>
                      )}
                  </td>
                </tr>

                <tr>
                  <td className="text-left pt-5">DRG Value</td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="drg_total"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId === 6 ? !enabled : true)
                      }
                      defaultValue={auditDetail?.drg_total}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.drg_total && isNaN(auditInfo?.drg_total) && (
                      <p className="help is-danger errorDanger">Required</p>
                    )}
                    {errors.drg_total &&
                      auditInfo?.drg_total < auditInfo?.drg_correct &&
                      !decimalRegex.test(auditInfo?.drg_total) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.drg_total &&
                      decimalRegex.test(auditInfo?.drg_total) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="drg_correct"
                      className="form-control"
                      disabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId === 6 ? !enabled : true)
                      }
                      defaultValue={auditDetail?.drg_correct}
                      onChange={handleInputChange}
                      onKeyUp={handleKeypress}
                    />
                    {errors.drg_correct && isNaN(auditInfo?.drg_correct) && (
                      <p className="help is-danger errorDanger">Required</p>
                    )}
                    {errors.drg_correct &&
                      auditInfo?.drg_total < auditInfo?.drg_correct &&
                      !decimalRegex.test(auditInfo?.drg_correct) && (
                        <p className="help is-danger errorDanger">
                          Total should be greater than or equal to correct
                        </p>
                      )}
                    {errors.poa_correct &&
                      decimalRegex.test(auditInfo?.drg_correct) && (
                        <p className="help is-danger errorDanger">
                          Only positive whole numbers are allowed
                        </p>
                      )}
                  </td>
                  <td>
                    {auditInfo?.drg_total !== auditInfo?.drg_correct &&
                    auditInfo?.drg_total > auditInfo?.drg_correct ? (
                      <Select
                        options={renderDrugValue()}
                        isMulti={true}
                        value={defaultDRG}
                        isDisabled={
                          !enabled ||
                          isSubmitting ||
                          isSubmitted ||
                          (clientData?.MilestoneId === 6 ? !enabled : true)
                        }
                        onChange={handleDRG}
                      />
                    ) : (
                      <Select
                        options={[]}
                        isMulti={true}
                        value={null}
                        isDisabled={true}
                        onChange={handleDRG}
                      />
                    )}
                    {errors.ModifierFeedbacks &&
                      (defaultModifier === undefined ||
                        defaultModifier?.length === 0) &&
                      auditInfo?.drg_total !== auditInfo?.drg_correct && (
                        <p className="help is-danger errorDanger">
                          {errors.ModifierFeedbacks}
                        </p>
                      )}
                  </td>
                </tr>

                {newAuditAreas?.map((item) => item?.FeedbackCategoryDropdowns?.length === 0 ? null :(
                  <NewAuditAreaInformation
                    key={item.id}
                    auditAreaInfo={item}
                    newAuditInfo={newAuditInfo}
                    setNewAuditInfoUpdatedData={setNewAuditInfoUpdatedData}
                    newAuditInfoUpdatedData={newAuditInfoUpdatedData}
                    newAuditAreasError={newAuditAreasError}
                    enabled={enabled}
                    isSubmitting={isSubmitting}
                    isSubmitted={isSubmitted} 
                    setFlag={setFlag}
                    validateAuditInfoForNewAuditAreas={validateAuditInfoForNewAuditAreas}
                  />
                ))}

                <tr >
                  <td className="text-left pt-5">Total</td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      id="total_total"
                      name="total_total"
                      className="form-control form-control-solid text-gray-400"
                      disabled={true}
                      value={total + (newAuditAreaTotal?.total || 0)}
                      onChange={handleInputChange}
                    />
                    {errors.total_total && (
                      <p className="help is-danger errorDanger">
                        {errors.total_total}
                      </p>
                    )}
                </td>
                  <td>
                    <input
                      type="number"
                      min={0}
                      name="total_correct"
                      className="form-control form-control-solid text-gray-400"
                      disabled={true}
                      value={correctSum + (newAuditAreaTotal?.correct || 0)}
                      onChange={handleInputChange}
                    />
                    {errors.total_correct && (
                      <p className="help is-danger errorDanger">
                        {errors.total_correct}
                      </p>
                    )}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="separator separator-dashed my-3" />
          <div className="d-flex flex-column gap-5 gap-md-7 mb-10 mt-10">
            <div className="row px-10">
              <div className="col-md-4 col-6">
                <label className="required form-label">Feedback Type</label>
                {(auditInfo?.prim_diag_total !== auditInfo?.prim_diag_correct &&
                  auditInfo?.prim_diag_total > auditInfo?.prim_diag_correct) ||
                (auditInfo?.sec_diag_total !== auditInfo?.sec_diag_correct &&
                  auditInfo?.sec_diag_total > auditInfo?.sec_diag_correct) ||
                (auditInfo?.proc_total !== auditInfo?.proc_correct &&
                  auditInfo?.proc_total > auditInfo?.proc_correct) ||
                (selectedEdTotal?.value !== selectedEdCorrect?.value &&
                  selectedEdTotal?.value > selectedEdCorrect?.value) ||
                (auditInfo?.modifier_total !== auditInfo?.modifier_correct &&
                  auditInfo?.modifier_total > auditInfo?.modifier_correct) ? (
                  <Select
                    value={defaultFeed !== null ? defaultFeed : null}
                    defaultValue={defaultFeed}
                    isDisabled={
                      !enabled ||
                      isSubmitting ||
                      isSubmitted ||
                      (clientData?.MilestoneId ===
                      milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                        ? !enabled
                        : true)
                    }
                    onChange={handledefaultFeed}
                    options={renderFeed()}
                  />
                ) : (
                  <Select
                    value={{ label: "", value: "" }}
                    isDisabled={true}
                    onChange={handledefaultFeed}
                    options={[]}
                  />
                )}
                {errors.FeedbackTypeId && defaultFeed?.value === null && (
                  <p className="help is-danger errorDanger">
                    {errors.FeedbackTypeId}
                  </p>
                )}
              </div>
              <div className="col-md-4 col-6">
                <label className="required form-label">Auditor QC Status</label>
                <Select
                  options={renderQC()}
                  defaultValue={
                    defaultQC?.value === 1 || defaultQC?.value === 2
                      ? defaultQC
                      : null
                  }
                  onChange={handledefaultQC}
                  name="QC_status"
                  isDisabled={
                    !enabled ||
                    isSubmitting ||
                    isSubmitted ||
                    (clientData?.MilestoneId ===
                      milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID ||
                    (renderQC()?.length !== 0 && auth.role === role.Auditor)
                      ? !enabled
                      : true)
                  }
                />
                {errors?.QC_status &&
                  (defaultQC?.value === qcStatusConstants.QC_IMPLEMENTED_ID ||
                    defaultQC?.value === qcStatusConstants.QC_REJECTED_ID) && (
                    <p className="help is-danger errorDanger">
                      {errors?.QC_status}
                    </p>
                  )}
              </div>
              {(auth.role === role.Auditor ||
                auth.role === role.Manager ||
                auth.role === role?.TeamLead) && (
                <div
                  className={
                    defaultQC?.value === qcStatusConstants.QC_PASS_ID ||
                    defaultQC?.value === undefined
                      ? "col-4 d-none"
                      : "col-4"
                  }
                >
                  <label className="required form-label">
                    Allocate to coder
                  </label>
                  {defaultQC?.value === qcStatusConstants.QC_FAIL_ID ? (
                    <Select
                      defaultValue={{
                        label: clientData?.Coder?.name,
                        value: clientData?.Coder?.id,
                      }}
                      value={defaultAllocateToCoder}
                      isDisabled={
                        !enabled ||
                        isSubmitting ||
                        isSubmitted ||
                        (clientData?.MilestoneId ===
                        milestoneConstants.AUDIT_IN_PROGRESS_MILESTONE_ID
                          ? !enabled
                          : true)
                      }
                      onChange={handleDefaultAllocateToCoder}
                      options={renderAllocateToCoder()}
                    />
                  ) : (
                    <Select
                      options={[]}
                      value={null}
                      isDisabled={true}
                      styles={{ visibility: "hidden" }}
                    />
                  )}
                  {errors.next_user_id && !defaultAllocateToAuditor && (
                    <p className="help is-danger errorDanger">
                      {errors.next_user_id}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {(auth.role === role.Auditor ||
        auth.role === role.Manager ||
        auth.role === role?.TeamLead) && (
        <div className="d-flex justify-content-start ms-5 mb-6">
          <button
            disabled={!enabled || isSubmitting || isSubmitted}
            onClick={submitChartForm}
            type="submit"
            className="btn fw-bold btn-primary me-2"
            style={{
              fontWeight: "bold",
              backgroundColor:
                isSubmitted || isSubmitting || !enabled ? "gray" : "",
              marginRight: "0.5rem",
              cursor: !enabled ? "not-allowed" : "pointer",
              color: "white",
            }}
          >
            Save
          </button>
          <button
            type="reset"
            className="btn btn-light fw-bold btn-active-light-primary"
            data-kt-search-element="preferences-dismiss"
          >
            Cancel
          </button>
        </div>
      )}
    </>
  );
}
export default React.memo(AuditInformation);
